export const getJSON = async (baseUrl, folder, file) => {
    const response = await fetch(`${baseUrl}/${folder}/${file}`);
    if (!response.ok) return null;
    return await response.json();
};